import { updateTimerDisplay } from '../ui/TimerDisplay';


export function startTimer(scene) {

    if (!scene.userTimer) {
        return;
    }

    /*
     * Make sure a previous timer cannot
     * survive into the new game.
     */
    scene.timerEvent?.remove(false);

    scene.timerEvent = null;

    scene.remainingTime = scene.startTime;

    updateTimerDisplay(scene);

    scene.timerEvent = scene.time.addEvent({
        delay: 1000,

        callback: () => {
            updateTimer(scene);
        },

        loop: true
    });
}


export function updateTimer(scene) {

    /*
    if (scene.gameMode !== 'timer') {
        return;
    }
    */
    if (!scene.userTimer) {
        return;
    }

    scene.remainingTime--;

    updateTimerDisplay(scene);

    if (scene.remainingTime <= 0) {
        scene.timerEvent?.remove(false);

        endGame(scene);
    }
}


export function endGame(scene) {
    scene.disableInput = true;
    scene.timeUp();
}